// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"cfad791a","462":"1de94af6","693":"d02429be","983":"a69f9231"}[chunkId] + ".chunk.js";
};